export default {
  InputEmpty: "silahkan masukkan {name}"
} as const;
